export function formatAmount(amount) {
  const roundedAmount = Math.floor(amount * 100) / 100;
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(roundedAmount);
}
